import { CellContext } from '@tanstack/react-table';
import { Product } from '@/types/menus.types';
import LockTooltip from '@/components/Icons/CustomIcons/LockTooltip';
import EyeOffTooltip from '@/components/Icons/CustomIcons/EyeOffTooltip';
import rowStyles from './TableRow.module.css';

const DisplayEyeLockTooltip = (productName: string) => (
  <div>
    <EyeOffTooltip content="This product is not visible for franchisee" className={rowStyles.eyeUpSvg} position="top" />
    <p>{productName}</p>
    <LockTooltip
      content="Edition is locked due to National Campaign"
      className={rowStyles.lockDownSvg}
      position="top"
    />
  </div>
);
const DisplayLockTooltip = (productName: string) => (
  <div>
    <LockTooltip content="Edition is locked due to National Campaign" className={rowStyles.lockUpSvg} position="top" />
    <p>{productName}</p>
  </div>
);
const DisplayEyeTooltip = (productName: string) => (
  <div>
    <EyeOffTooltip content="This product is not visible for franchisee" className={rowStyles.eyeUpSvg} position="top" />
    <p>{productName}</p>
  </div>
);

export const IconTooltipCell = ({ row }: CellContext<Product, unknown>) => {
  const {
    original: { lock, chosenPrice, productName },
  } = row;

  return (
    <>
      {lock && chosenPrice === 99.99 && DisplayEyeLockTooltip(row.original.productName)}
      {lock && chosenPrice !== 99.99 && DisplayLockTooltip(row.original.productName)}
      {!lock && chosenPrice === 99.99 && DisplayEyeTooltip(row.original.productName)}
      {!lock && chosenPrice !== 99.99 && <p>{productName}</p>}
    </>
  );
};
